<template>
  <section class="">
    <div class="dashboard-wrapper">
      <div class="container">
        <div class="dashboard-card-warpper">
          <!-- 1 -->
          <vendor-details-dashboard>
          </vendor-details-dashboard>
          <div class="horizontal-line"></div>
          <!-- 2 -->
          <!--:gstApproval="gstApproval"-->
          <vendor-bank-details-dashboard>
          </vendor-bank-details-dashboard>
          <div class="horizontal-line"></div>
          <!-- 3 -->
          <vendor-store-details-dashboard>
          </vendor-store-details-dashboard>
        </div>
      </div>
    </div>
    <div class="dashboard-help">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 mt-4">
            <h4 data-test="vendorDashboardLabel1"
																id="vendorDashboardLabel1">
              FAQ
            </h4>
            <div
              class="accordion mt-3"
              id="accordionExample1"
            >
              <div class="card">
                <div
                  class="card-header"
                  id="headingOne1"
                >
                  <h2 class="mb-0"
																						data-test="vendorDashboardLabel2"
																						id="vendorDashboardLabel2">
                    <button
                      class="btn btn-link"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
																						data-test="vendorDashboardBtn1"
																						id="vendorDashboardBtn1"
                    >Collapsible Group Item #1
                    </button>
                  </h2>
                </div>

                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne1"
                  data-parent="#accordionExample1"
                >
                  <div class="card-body"
																							data-test="vendorDashboardPara1"
																							id="vendorDashboardPara1">
                    Anim pariatur cliche reprehenderit, enim eiusmod high
                    life accusamus terry richardson ad squid.
                    3 wolf moon officia aute, non cupidatat skateboard
                    dolor brunch. Food truck quinoa nesciunt laborum
                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a
                    bird on it squid single-origin coffee nulla
                    assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred
                    nesciunt sapiente ea proident. Ad vegan excepteur
                    butcher vice lomo. Leggings occaecat craft beer
                    farm-to-table, raw denim aesthetic synth nesciunt you
                    probably haven't heard of them accusamus
                    labore sustainable VHS.
                  </div>
                </div>
              </div>
              <div class="card">
                <div
                  class="card-header"
                  id="headingTwo1"
                >
                  <h2 class="mb-0"
																						data-test="vendorDashboardLabel3"
																						id="vendorDashboardLabel3">
                    <button
                      class="btn btn-link collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
																						data-test="vendorDashboardBtn2"
																						id="vendorDashboardBtn2"
                    >
                      Collapsible Group Item #2
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTwo"
                  class="collapse"
                  aria-labelledby="headingTwo1"
                  data-parent="#accordionExample1"
                >
                  <div class="card-body"
																							data-test="vendorDashboardPara2"
																							id="vendorDashboardPara2">
                    Anim pariatur cliche reprehenderit, enim eiusmod high
                    life accusamus terry richardson ad squid.
                    3 wolf moon officia aute, non cupidatat skateboard
                    dolor brunch. Food truck quinoa nesciunt laborum
                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a
                    bird on it squid single-origin coffee nulla
                    assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred
                    nesciunt sapiente ea proident. Ad vegan excepteur
                    butcher vice lomo. Leggings occaecat craft beer
                    farm-to-table, raw denim aesthetic synth nesciunt you
                    probably haven't heard of them accusamus
                    labore sustainable VHS.
                  </div>
                </div>
              </div>
              <div class="card">
                <div
                  class="card-header"
                  id="headingThree1"
                >
                  <h2 class="mb-0"
																						data-test="vendorDashboardLabel4"
																						id="vendorDashboardLabel4">
                    <button
                      class="btn btn-link collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
																						data-test="vendorDashboardBtn3"
																						id="vendorDashboardBtn3"
                    >
                      Collapsible Group Item #3
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseThree"
                  class="collapse"
                  aria-labelledby="headingThree1"
                  data-parent="#accordionExample1"
                >
                  <div class="card-body"
																							data-test="vendorDashboardPara3"
																							id="vendorDashboardPara3">
                    Anim pariatur cliche reprehenderit, enim eiusmod high
                    life accusamus terry richardson ad squid.
                    3 wolf moon officia aute, non cupidatat skateboard
                    dolor brunch. Food truck quinoa nesciunt laborum
                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a
                    bird on it squid single-origin coffee nulla
                    assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred
                    nesciunt sapiente ea proident. Ad vegan excepteur
                    butcher vice lomo. Leggings occaecat craft beer
                    farm-to-table, raw denim aesthetic synth nesciunt you
                    probably haven't heard of them accusamus
                    labore sustainable VHS.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mt-4">
            <h4 data-test="vendorDashboardLabel5">Pricing</h4>
            <div
              class="accordion mt-3"
              id="accordionExample"
            >
              <div class="card">
                <div
                  class="card-header"
                  id="headingOne"
                >
                  <h2 class="mb-0"
																						data-test="vendorDashboardLabel6"
																						id="vendorDashboardLabel6">
                    <button
                      class="btn btn-link"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseOne1"
                      aria-expanded="true"
                      aria-controls="collapseOne1"
																						data-test="vendorDashboardBtn4"
																						id="vendorDashboardBtn4"
                    >
                      Collapsible Group Item #1
                    </button>
                  </h2>
                </div>

                <div
                  id="collapseOne1"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body"
																							data-test="vendorDashboardPara4"
																							id="vendorDashboardPara4">
                    Anim pariatur cliche reprehenderit, enim eiusmod high
                    life accusamus terry richardson ad squid.
                    3 wolf moon officia aute, non cupidatat skateboard
                    dolor brunch. Food truck quinoa nesciunt laborum
                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a
                    bird on it squid single-origin coffee nulla
                    assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred
                    nesciunt sapiente ea proident. Ad vegan excepteur
                    butcher vice lomo. Leggings occaecat craft beer
                    farm-to-table, raw denim aesthetic synth nesciunt you
                    probably haven't heard of them accusamus
                    labore sustainable VHS.
                  </div>
                </div>
              </div>
              <div class="card">
                <div
                  class="card-header"
                  id="headingTwo"
                >
                  <h2 class="mb-0"
																						data-test="vendorDashboardLabel7"
																						id="vendorDashboardLabel7">
                    <button
                      class="btn btn-link collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwo2"
                      aria-expanded="false"
                      aria-controls="collapseTwo2"
																						data-test="vendorDashboardBtn5"
																						id="vendorDashboardBtn5"
                    >
                      Collapsible Group Item #2
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTwo2"
                  class="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionExample"
                >
                  <div class="card-body"
																							data-test="vendorDashboardPara5"
																							id="vendorDashboardPara5">
                    Anim pariatur cliche reprehenderit, enim eiusmod high
                    life accusamus terry richardson ad squid.
                    3 wolf moon officia aute, non cupidatat skateboard
                    dolor brunch. Food truck quinoa nesciunt laborum
                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a
                    bird on it squid single-origin coffee nulla
                    assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred
                    nesciunt sapiente ea proident. Ad vegan excepteur
                    butcher vice lomo. Leggings occaecat craft beer
                    farm-to-table, raw denim aesthetic synth nesciunt you
                    probably haven't heard of them accusamus
                    labore sustainable VHS.
                  </div>
                </div>
              </div>
              <div class="card">
                <div
                  class="card-header"
                  id="headingThree"
                >
                  <h2 class="mb-0"
																						data-test="vendorDashboardLabel8"
																						id="vendorDashboardLabel8"
																		>
                    <button
                      class="btn btn-link collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseThree3"
                      aria-expanded="false"
                      aria-controls="collapseThree3"
																						data-test="vendorDashboardBtn6"
																						id="vendorDashboardBtn6"
                    >
                      Collapsible Group Item #3
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseThree3"
                  class="collapse"
                  aria-labelledby="headingThree"
                  data-parent="#accordionExample"
                >
                  <div class="card-body"
																							data-test="vendorDashboardPara6"
																							id="vendorDashboardPara6">
                    Anim pariatur cliche reprehenderit, enim eiusmod high
                    life accusamus terry richardson ad squid.
                    3 wolf moon officia aute, non cupidatat skateboard
                    dolor brunch. Food truck quinoa nesciunt laborum
                    eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a
                    bird on it squid single-origin coffee nulla
                    assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred
                    nesciunt sapiente ea proident. Ad vegan excepteur
                    butcher vice lomo. Leggings occaecat craft beer
                    farm-to-table, raw denim aesthetic synth nesciunt you
                    probably haven't heard of them accusamus
                    labore sustainable VHS.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import VendorDetailsDashboard from '../dashboard/widgets/vendorDetailsDashboard'
import VendorBankDetailsDashboard from '../dashboard/widgets/vendorBankDetailsDashboard'
import VendorStoreDetailsDashboard from './widgets/vendorStoreDetailsDashboard'

export default {
	components: {
		VendorStoreDetailsDashboard,
		VendorBankDetailsDashboard,
		VendorDetailsDashboard
	},
	data () {
		return {
			gstApproval: false
		}
	},
	computed: {
		...mapGetters('vendor', ['getStatusData'])
	},
	mounted () {
		//
		// this.gstApproval = this.getStatusData.bank_account_status;
	}
}
</script>

<style>
</style>
